// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_CREDENTIALSNT = 'GET_CREDENTIALSNT';
export const CREATE_CREDENTIALSNT = 'CREATE_CREDENTIALSNT';
export const UPDATE_CREDENTIALSNT = 'UPDATE_CREDENTIALSNT';
export const DELETE_CREDENTIALSNT = 'DELETE_CREDENTIALSNT';
export const GET_CREDENTIALSNT_STATES = 'GET_CREDENTIALSNT_STATES';
export const GET_CREDENTIALSNT_SPECIALTIES = 'GET_CREDENTIALSNT_SPECIALTIES';
